import { gql, useMutation } from '@apollo/client';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';

const MUTATION = gql`
mutation RemoveInstaller($id: Float!) {
    removeInstaller(id: $id)
}
`;

export const useRemoveInstaller = (): [
    (id: string) => Promise<boolean>,
    MutationResult<boolean, 'success'>
] => {
    const [mutation, { called, data, loading }] = useMutation<boolean, { id: number }>(MUTATION);

    return [
        useCallback(async (id: string) => {
            const response = await mutation({ variables: { id: Number(id) }});

            return !!response.data;
        }, [mutation]),
        {
            called,
            loading,
            success: !!data
        }
    ];
};
